export const ADD_COMPONENT = "Add Component";
export const CHANGE_PROP = "Change Prop";
export const CHANGE_VALUE_JSON = "Change Value";